export default {
    data() {
        return {
            // 分页器每页个数
            pageSize: 15,
            // 分页器页数
            currentPage: 1,
            // 行业类别
            industryCategories: '',
            // 课程名称
            courseName: '',
            // 支付类型
            typeSearch: '',
            // 订单状态
            statusType: '',
            // 所有订单数据
            OrdersData: [],
            // 加载等待
            loading: false,
            // 支付方式
            orderSearchType: [
                {

                    value: "3",
                    label: "批量开课"
                },
                {
                    value: "5",
                    label: "账号余额"
                },
                {
                    value: "6",
                    label: "郑州银行"
                }
            ],
            // 支付状态
            invoicesStatusType: [{
                value: " ",
                label: "全部订单"
            },
            {
                value: "2",
                label: "已支付订单"
            },
            {
                value: "5",
                label: "已失效订单"
            },
            {
                value: "0",
                label: "未支付订单"
            }
            ],
            total: 0,
        }

    },
    methods: {

        // 导出购买记录
        exportPurchaseRecords() {
            this.$post('orders/export_record', {
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                token: this.$store.state.authority_management,
                label_name: this.industryCategories,
                product_name: this.courseName,
                pay_type: this.typeSearch,
                state: this.statusType,
                shop_id: this.$store.state.store.id
            }).then(res => {
                // console.log(res)
                // 
                let flie = res.data.result
                let url = this.baseUrl + "export_excel/" + flie + ".csv"
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', flie + '.csv')
                document.body.appendChild(link)
                link.click()
            })
        },

        // 搜索按钮
        confirmSearch() {
            this.currentPage = 1
            this.loading = true
            this.$post('orders/get_records', {
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                shop_id: this.$store.state.store.id,
                token: this.$store.state.authority_management,
                pay_type: this.typeSearch,
                state: this.statusType,
                // search_label_name: this.industryCategories,
                category_name: this.courseName
            }).then(res => {
                this.OrdersData = res.data.result.data
                this.total = res.data.result.total
                this.loading = false
            })
        },

        // 获取订单数据
        getOrdersData() {
            this.loading = true
            this.$post('orders/get_records', {
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                shop_id: this.$store.state.store.id,
                token: this.$store.state.authority_management,
                pay_type: this.typeSearch,
                state: this.statusType,
                // search_label_name: this.industryCategories,
                category_name: this.courseName
            }).then(res => {
                this.OrdersData = res.data.result.data
                this.total = res.data.result.total
                this.loading = false
            })
        },
        // 改变每页个数时
        handleSizeChange(SizeChange) {
            this.pageSize = SizeChange
            this.getOrdersData()
        },
        // 改变页数时
        handleCurrentChange(current) {
            this.currentPage = current
            this.getOrdersData()
        }

    },
    created() {
        // 获取订单数据
        this.getOrdersData()
    },
}
